@if(dataVisible$ | async) {
  <form [formGroup]="formGroup">
    <div class="row">
      <div class="col col-1">
        Inkomen uit aanmerkelijk belang
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control
          [decimals]="0"
          align="right"
          class="custom-input-150"
          formControlName="inkomen"
          id="inkomen"
          prefix="€"
        ></snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
      <div class="col-4"></div>
    </div>
    <div class="row">
      <div class="col col-1">
        Verrekende persoonsgebonden aftrek
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control
          [decimals]="0"
          align="right"
          class="custom-input-150"
          formControlName="persoonsgebondenAftrek"
          id="persoonsgebondenAftrek"
          prefix="€ -"
        ></snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
      <div class="col-4"></div>
    </div>
    <div class="row">
      <div class="col col-1">
        <b>Belastbaar inkomen uit aanmerkelijk belang {{ isPartnerView ? 'partner' : 'aangever' }}</b>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control
          [decimals]="0"
          align="right"
          class="custom-input-150"
          formControlName="belastbaarInkomen"
          id="belastbaarInkomen"
          prefix="€"
        ></snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
      <div class="col-4"></div>
    </div>
</form>
}
